import React from 'react';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTranslation } from 'react-i18next';
import './VerifiedBadge.css';

export default function VerifiedBadge({ size = 16, withLabel = false, className = '' }) {
  const { t } = useTranslation();
  return (
    <span className={`verified-badge ${className}`} title={t('verifiedSeller')}>
      <VerifiedIcon sx={{ fontSize: size, color: '#1877F2' }} />
      {withLabel && <span className="verified-badge__label">{t('verifiedBadge')}</span>}
    </span>
  );
}
